import type { ContentGrader, GradingResult, ScoringConfig } from '@ai-content-hub/content-core';
import type { DocumentsAnswer, DocumentsData } from './schema';

function isValidCompletionAnswer(answer: unknown): answer is DocumentsAnswer {
    if (!answer || typeof answer !== 'object') return false;
    const a = answer as DocumentsAnswer;
    return a.completed === true;
}

export function validateDocumentsSubmission(answer: unknown, _data: DocumentsData): boolean {
    return isValidCompletionAnswer(answer);
}

export const documentsContentGrader: ContentGrader<DocumentsData, DocumentsAnswer> = {
    grade: (
        _data: DocumentsData,
        answer: DocumentsAnswer | undefined,
        _scoring: ScoringConfig | undefined,
        _context
    ): GradingResult => {
        if (!isValidCompletionAnswer(answer)) {
            return { isCorrect: false, score: 0, max: 1 };
        }
        return {
            isCorrect: true,
            score: 1,
            max: 1,
            details: {
                viewedSeconds: answer.viewedSeconds,
                scrolledToEnd: answer.scrolledToEnd,
            },
        };
    },
    validateAnswer: (answer, data) => validateDocumentsSubmission(answer, data),
};
